import React, { useState, useEffect ,useRef} from 'react';
import { BASE_URL } from '../utils/config';
import { useNavigate } from 'react-router-dom';
import {Tabs,Tab} from '@mui/material';
import iconStockmarket from "../images/icon-stockmarket-01.png";
import iconOptions from "../images/icon-stockmarket-02.png";
import iconDelivery from "../images/icon-stockmarket-03.png";
import ScreenerTab from '../components/dashboard/screenertab';
import MCXTable from '../components/dashboard/mcxtable';
import TelegramWidget from '../components/widget/telegramWidget';
import IndexIntradayTable from '../components/dashboard/indexIntradayTable';
import NKBTab from "../components/dashboard/nkbtab";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@mui/material";


const DashBorad = () => {
  const [tabs, setTabs] = useState([
    { id: 'screener', label: 'Screener', data: [],previousClose:[],active: true},
    { id: 'future', label: 'Future', data: [],previousClose:[],active: false },
    { id: 'option', label: 'Option', data: [] , automateScriptData:[],previousClose:[],active: false},
    { id: 'delivery', label: 'Delivery', data: [],previousClose:[],active: false},
    { id: 'hni', label: 'HNI', data: [],previousClose:[],active: false },
    { id: 'intraDay', label: 'IntraDay', data: [] ,previousClose:[],active: false},
    { id: 'mcx', label: 'MCX', data: [] ,previousClose:[],active: false},
    { id: 'IndexIntraday', label: 'IndexIntraday', data: [] ,previousClose:[],active: false},
    { id: 'nkb', label: 'nkb', data: [] ,previousClose:[],active: false}
  ]);
  const navigate = useNavigate();
    
  const[screenerTab,setScreenerTab]=useState(true)
  const[futureTab,setFutureTab]=useState(false)
  const[optionTab,setOptionTab]=useState(false)
  const[intraDayTab,setIntraDayTab]=useState(false)
  const[indexIntraDayTab,setIndexIntraDayTab]=useState(false)
  const[deliveryTab,setDeliveryTab]=useState(false)
  const[hniTab,setHNITab]=useState(false)
  const[mcx,setMCXTab]=useState(false)
  const[screenerRecord,setScreenerRecord]=useState(0)
  const[futureRecord,setFutureRecord]=useState(0)
  const[optionRecord,setOptionRecord]=useState(0)
  const[deliveryRecord,setDeliveryRecord]=useState(0)
  const[hniRecord,setHNIRecord]=useState(0)
  const[mcxRecord,setMCXRecord]=useState(0)
  const[selectedTabId,setSelectedTabId]=useState('screener')
  const [value, setValue] = useState(0);
  const [MCXData, setMCXData] = useState([]);
  const [AutomateMCXData, setAutomateMCXData] = useState([]);
  const [errorDialog,setErrorDialog]=useState(false);
  const [errorMessage,setErrorMessage]=useState("");
  const countRef = useRef(0);

  const [nkbTab, setNKBTab] = useState(false);
  const [nkbRecord, setNKBRecord] = useState(0);

 

useEffect(() => {
   // Use useRef to persist count value

  const fetchDataInterval = setInterval(async () => {
    try {
      console.log("inside check for interval", selectedTabId);
      await fetchDataForAllTabs(selectedTabId);
      await fetchDataPreviousClose(selectedTabId);
    } catch (error) {
      console.error("Error in interval fetch:", error);
    }
  }, 60000); // 60,000 milliseconds = 1 minute

   fetchDataForAllTabs('screener');
   fetchDataPreviousClose('screener');
  // Initial fetch when count is 0
  // if (countRef.current === 0) {
  //   fetch(`${BASE_URL}/generatekitesession`, {
  //     method: 'GET',
  //   })
  //     .then((response) => response.json())
  //     .then((res) => {
  //       console.log("response",res)
  //     if (res.success === true) {
  //       fetchDataForAllTabs('screener');
  //       fetchDataPreviousClose('screener');
  //     } else {
  //       console.error("API Error:", res.message || "Unknown error occurred");
  //       // alert(res.message || "Failed to generate kite session");
  //       setErrorMessage(`Error: ${res.message}`);
  //   setErrorDialog(true)
  //   setTimeout(() => {
  //     setErrorDialog(false)
  //     setErrorMessage("")
  //     }, 1700);
  //     }
  //     })
  //     .catch((error) => {
  //     console.error("Error in initial fetch:", error);
      
  //     setErrorMessage(`Error: ${error.message}`);
  //     setErrorDialog(true)
  //     setTimeout(() => {
  //       setErrorDialog(false)
  //       setErrorMessage("")
  //       }, 1700);
  //     });
  //   countRef.current += 1;
  // }

  // Cleanup the interval on component unmount
  return () => clearInterval(fetchDataInterval);
}, [selectedTabId]);


//  this fucntion is used to fetch data from api based on selected tab
const fetchDataForAllTabs = async (tabId) => {
  console.log("fetch record details for tabId:", tabId);
  try {
    let updatedTabs = [...tabs]; // Clone the tabs array to update its state
    let tab = updatedTabs.find(t => t.id === tabId); // Find the tab with the matching tabId

    if (!tab) {
      console.error('Tab not found:', tabId);
      return;
    }

    const response = await fetch(`${BASE_URL}/getAllReportList/${tabId}`, {
      method: 'GET'
    });

    if (!response.ok) {
      if (response.status === 403 || response.status === 401) {
        console.error('Unauthorized or Forbidden. Redirecting to login...');
        setTimeout(() => {
          localStorage.clear();
          navigate('/login');
        }, 3000);
      }
      return;
    }

    const res = await response.json();

    if (res.success === true) {
      console.log("res.data", res.data);
      console.log("res.automateData", res.automateData);

      if (tabId === 'screener') {
        setScreenerRecord(prevCount => prevCount + 1);
      }

      if (tabId === 'option') {
        console.log("inside option tab to set option data");
        tab.data = res.data;
        tab.automateScriptData = res.automateData;
      } else {
        tab.data = res.data;
      }
    } else {
      console.error('Error in response:', res.message || 'Unknown error occurred');
    
      setErrorMessage(`Error: ${res.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    }

    // Update the state with the new tabs array
    setTabs(updatedTabs);

  } catch (error) {
    console.error('Error fetching data:', error);
    // alert('An error occurred while fetching data. Please try again.');
    
    setErrorMessage(`Error: ${error.message}`);
    setErrorDialog(true)
    setTimeout(() => {
      setErrorDialog(false)
      setErrorMessage("")
      }, 1700);
  }
};


//  this fucntion is used to fetch previous close record 
const fetchDataPreviousClose = async (tabId) => {
  let loginuser = JSON.parse(localStorage.getItem("loginData"));
  console.log("Previous fetch record details for tabId:", tabId);
  try {
    let updatedTabs = [...tabs]; // Clone the tabs array to update its state
    let tab = updatedTabs.find(t => t.id === tabId); // Find the tab with the matching tabId

    if (!tab) {
      console.error('Tab not found:', tabId);
      return;
    }

    const response = await fetch(`${BASE_URL}/previousclose/${tabId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${loginuser.token}`
      }
    });

    if (!response.ok) {
      if (response.status === 403 || response.status === 401) {
        console.error('Unauthorized or Forbidden. Redirecting to login...');
        setTimeout(() => {
          localStorage.clear();
          navigate('/login');
        }, 3000);
      } 
      return;
    }

    const res = await response.json();

    if (res.success === true) {
  console.log("res.data previous Close", res.previousCloseData);

  if (tabId === 'screener') {
    setScreenerRecord(prevCount => prevCount + 1);
  }

  if (tabId === 'nkb') {
  tab.previousClose = res.previousCloseData.map(item => {
    const entry = Number(item.PriceAtSignal ?? 0);
    const exit = Number(item.PriceAtExit ?? 0);

    let pl = '-';

    if (item.SignalFinal === 'BUY NKB' && exit) {
      pl = (exit - entry).toFixed(2);
    }

    if (item.SignalFinal === 'SELL NKB' && exit) {
      pl = (entry - exit).toFixed(2);
    }

    return {
      Decision: item.SignalFinal,
      Index: item.SignalType,
      SignalDT: item.SignalDT || (item.datetime ? new Date(item.datetime).toLocaleString("en-IN") : '-'),
      EntryPrice: entry || '-',
      SL: item.SignalStopLoss || '-',
      PriceAtExit: exit || '-',
      ExitDt: item.ExitDt || '-',
      PL: pl,               
      SLTrigger: item.SLTrigger ?? '-',
      HAS: item.HighAfterSignal ?? '-',
      LAS: item.LowAfterSignal ?? '-',
      HDate: item.HighDT ?? '-',
      LDate: item.LowDT ?? '-',
      FavMoves: item.FavMoves ?? '-',
      LastCheckedDt: item.LastCheckedDT ?? '-'
    };
  });
}
 else {
    // existing behavior for other tabs
    tab.previousClose = res.previousCloseData;
  }
}
    
    else {
      console.error('Error in response:', res.message || 'Unknown error occurred');
      
      setErrorMessage(`Error: ${res.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    }

    // Update the state with the new tabs array
    setTabs(updatedTabs);

  } catch (error) {
    console.error('Error fetching data:', error);
          setErrorMessage(`Error: ${error.message}`);
          setErrorDialog(true)
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage("")
            }, 1700);
  }
};

 
// this fucntion is used to handle tab selecton
  const handletabSelection = async (event, type) => {
    try {
      console.log("type from single click", tabs);

      if (!type) {
        console.error("Invalid tab type provided:", type);
        alert("Invalid tab type selected. Please try again.");
        return;
      }

      setSelectedTabId(type);

      if (type === "mcx") {
        await fetchMCXData();
      } else {
        await fetchDataForAllTabs(type);
        await fetchDataPreviousClose(type);
      }

      switch (type) {
        case "screener":
          setScreenerRecord((prevCount) => prevCount + 1);
          setDeliveryTab(false);
          setOptionTab(false);
          setHNITab(false);
          setFutureTab(false);
          setIntraDayTab(false);
          setMCXTab(false);
          setIndexIntraDayTab(false);
          setScreenerTab(true);
          break;
        case "future":
          setFutureRecord((prevCount) => prevCount + 1);
          setDeliveryTab(false);
          setOptionTab(false);
          setHNITab(false);
          setScreenerTab(false);
          setIntraDayTab(false);
          setMCXTab(false);
          setIndexIntraDayTab(false);
          setFutureTab(true);
          break;
        case "option":
          setOptionRecord((prevCount) => prevCount + 1);
          setDeliveryTab(false);
          setHNITab(false);
          setFutureTab(false);
          setScreenerTab(false);
          setIntraDayTab(false);
          setMCXTab(false);
          setIndexIntraDayTab(false);
          setOptionTab(true);
          break;
        case "intraDay":
          setOptionRecord((prevCount) => prevCount + 1);
          setDeliveryTab(false);
          setHNITab(false);
          setFutureTab(false);
          setScreenerTab(false);
          setOptionTab(false);
          setMCXTab(false);
          setIndexIntraDayTab(false);
          setIntraDayTab(true);
          break;
        case "IndexIntraday":
          setOptionRecord((prevCount) => prevCount + 1);
          setDeliveryTab(false);
          setHNITab(false);
          setFutureTab(false);
          setScreenerTab(false);
          setOptionTab(false);
          setMCXTab(false);
          setIntraDayTab(false);
          setIndexIntraDayTab(true);
          break;
        case "delivery":
          setDeliveryRecord((prevCount) => prevCount + 1);
          setOptionTab(false);
          setHNITab(false);
          setFutureTab(false);
          setScreenerTab(false);
          setIntraDayTab(false);
          setMCXTab(false);
          setIndexIntraDayTab(false);
          setDeliveryTab(true);
          break;
        case "hni":
          setHNIRecord((prevCount) => prevCount + 1);
          setDeliveryTab(false);
          setOptionTab(false);
          setScreenerTab(false);
          setFutureTab(false);
          setIntraDayTab(false);
          setMCXTab(false);
          setIndexIntraDayTab(false);
          setHNITab(true);
          break;
        case "mcx":
          setMCXRecord((prevCount) => prevCount + 1);
          setDeliveryTab(false);
          setOptionTab(false);
          setScreenerTab(false);
          setFutureTab(false);
          setIntraDayTab(false);
          setHNITab(false);
          setIndexIntraDayTab(false);
          setMCXTab(true);
          break;

case "nkb":
  setNKBRecord(prev => prev + 1);

  setScreenerTab(false);
  setFutureTab(false);
  setOptionTab(false);
  setIntraDayTab(false);
  setIndexIntraDayTab(false);
  setDeliveryTab(false);
  setHNITab(false);
  setMCXTab(false);

  setNKBTab(true);
  break;

        default:
          console.error("Unknown tabId:", type);
          alert("Unknown tab selected. Please try again.");
      }
    } catch (error) {
      console.error("Error in handletabSelection:", error);
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    }
  };
  
//  this function is used to  change tab
  const handleChange = (event, newValue) => {

    setValue(newValue);
  };


  //  this fucntion is used to chalge sl
  const updateSLchangefunction = async(tabId) =>{

    fetchDataForAllTabs(tabId);
    fetchDataPreviousClose(tabId);
  }


  //  this fucntion is used to featch mCX Data
  const fetchMCXData = async () => {
    console.log("Fetching MCX data...");
    try {
      const response = await fetch(`${BASE_URL}/getAllMCXdata/`, {
        method: 'GET',
      });

      console.log("response",response)

      if (!response.ok) {
        if (response.status === 403 || response.status === 401) {
          console.error('Unauthorized or Forbidden. Redirecting to login...');
          setTimeout(() => {
            localStorage.clear();
            navigate('/login');
          }, 3000);
        } 
        return;
      }

      const res = await response.json();
      console.log("res",res)
      if (res.success === true) {
        setMCXData(res.data);
        setAutomateMCXData(res.data1);
      } else {
        console.error('Error in response:', res.message || 'Unknown error occurred');
        alert(res.message || 'Failed to fetch MCX data.');
      }
    } catch (error) {
      console.error('Error fetching MCX data:', error);
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    }
  };
  

  return (
    <div>
     
    
      <div className='Dashboard-container container-block'>
      

      <Tabs
      orientation="vertical"
      variant="scrollable"
      value={value}
      onChange={handleChange}
      aria-label="icon position tabs example"
      className='dashboard-tabs-main-btn'
    >
      <Tab className='dashboard-tab-btn'  icon={ <img className="dashboard-icon" src={iconStockmarket} alt="Icon" />} iconPosition="top" label="F&O Screener" onClick={(e)=>{handletabSelection(e,'screener')}}/>

      <Tab className='dashboard-tab-btn'  icon={ <img className="dashboard-icon" src={iconDelivery} alt="Icon" />} iconPosition="top" label="MCX"  onClick={(e)=>{handletabSelection(e,'mcx')}} />

      <Tab className='dashboard-tab-btn'  icon={ <img className="dashboard-icon" src={iconOptions} alt="Icon" />} iconPosition="top" label="NKB"  onClick={(e)=>{handletabSelection(e,'nkb')}} />

      {/* <Tab className='dashboard-tab-btn'  icon={ <img className="dashboard-icon" src={iconOptions} alt="Icon" />} iconPosition="top" label="Index Intraday"  onClick={(e)=>{handletabSelection(e,'IndexIntraday')}} /> */}

      <Tab className='dashboard-tab-btn'  icon={ <img className="dashboard-icon" src={iconStockmarket} alt="Icon" />} iconPosition="top" label="Future" onClick={(e)=>{handletabSelection(e,'future')}}/>

      <Tab className='dashboard-tab-btn'  icon={ <img className="dashboard-icon" src={iconOptions} alt="Icon" />} iconPosition="top" label="Option"  onClick={(e)=>{handletabSelection(e,'option')}} />
     
      <Tab className='dashboard-tab-btn' icon={ <img className="dashboard-icon" src={iconDelivery} alt="Icon" />} iconPosition="top" label="Delivery"  onClick={(e)=>{handletabSelection(e,'delivery')}} />

      <Tab className='dashboard-tab-btn'  icon={ <img className="dashboard-icon" src={iconDelivery} alt="Icon" />} iconPosition="top" label="HNI"  onClick={(e)=>{handletabSelection(e,'hni')}} />

     
      

    </Tabs>
  
    {
    screenerTab?
      <ScreenerTab Record={tabs[0].data} heading={'Screener Tab'} updateSLchange={() => updateSLchangefunction(tabs[0].id)} RecordColor={screenerRecord} PreviousClose={tabs[0].previousClose}/>
    :futureTab?
      <ScreenerTab Record={tabs[1].data}heading={'Future Tab'} updateSLchange={() => updateSLchangefunction(tabs[1].id)} RecordColor={futureRecord} PreviousClose={tabs[1].previousClose}/>
    :optionTab?
       <ScreenerTab Record={tabs[2].data} AutomateRecord={tabs[2].automateScriptData} heading={'Option Tab'} updateSLchange={() => updateSLchangefunction(tabs[2].id)} RecordColor={optionRecord} PreviousClose={tabs[2].previousClose}/>
    
    :intraDayTab?
       <ScreenerTab Record={tabs[5].data}  heading={'IntraDay Tab'} updateSLchange={() => updateSLchangefunction(tabs[5].id)} RecordColor={optionRecord} PreviousClose={tabs[5].previousClose}/>
      
       :indexIntraDayTab?

      <IndexIntradayTable Record={tabs[7].data} heading={'Index IntraDay Tab'} RecordColor={optionRecord} PreviousClose={tabs[7].previousClose} updateSLchange={() => updateSLchangefunction(tabs[7].id)}/>
    :deliveryTab?
       <ScreenerTab Record={tabs[3].data} heading={'Delivery Tab'} updateSLchange={() => updateSLchangefunction(tabs[3].id)} RecordColor={deliveryRecord} PreviousClose={tabs[3].previousClose}/>
    :hniTab?
        <ScreenerTab Record={tabs[4].data} heading={'HNI Tab'} updateSLchange={() => updateSLchangefunction(tabs[4].id)} RecordColor={hniRecord} PreviousClose={tabs[4].previousClose}/>
    :mcx?
    <MCXTable Record={MCXData} Record1={AutomateMCXData} heading={'MCX Dashboard'} updateSLchange={fetchMCXData} RecordColor={mcxRecord} />

: nkbTab ?
  <NKBTab
    Record={tabs[8].data}
    PreviousClose={tabs[8].previousClose}
    onRefresh={() => {
        fetchDataForAllTabs("nkb");
        fetchDataPreviousClose("nkb");
      }}
    />

    :null}
               
     
    <TelegramWidget/>
  
    {/*Error Message Dialog */}
            <Dialog
        open={errorDialog}
        onClose={()=>{setErrorDialog(false)}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle  id="alert-dialog-title">
        <h4 style={{ color: "red" }}>Failure</h4>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           
                 
            {errorMessage}
             
          
          </DialogContentText>
        </DialogContent>
       
            </Dialog>
      </div>
    </div>
 );
};

export default DashBorad;
